import { Button, ButtonType } from "components/Button/Button";
import './SearchResultItem.scss';
import MediaType from "components/MediaType/MediaType";
import { ModuleStateType } from "utils/constants";
import { faClock, faLock } from "@fortawesome/free-solid-svg-icons";
import useUserData from "hooks/useUserData";
import { UserRoles } from "utils/userRoles";
import useBranding from "hooks/useBranding";
import { useModal } from 'components/Modal/context/ModalContext';
import { GetLockedContentModalData, GetLockedLearningJourneyModalData } from "components/Modal/utils/lockedContentModalData";

const SearchResultItem = ({ searchResults, searchTerm }) => {
	const escapeRegExp = (string) => {
		return string.replace(/[.*+?^${}()|[\]\\$&]/g, '\\$&');
	};

	const { userData } = useUserData();
	const { contactDetails } = useBranding();
	const { openModal } = useModal();

	const handleOpenLockModal = (state, rule) => {
		let data = {};
		if (state === ModuleStateType.DisabledUpsell) {
			data = GetLockedContentModalData(userData.UserLevel === UserRoles.Learner, contactDetails.Number, contactDetails.Email);
		}
		else {
			data = GetLockedLearningJourneyModalData(Number(rule));
		}
		openModal(data.title, data.content);
	};

	const highlightTerm = (text, term) => {
		if (!term) {
			return text;
		}

		const escapedTerm = escapeRegExp(term);
		const regex = new RegExp(`(${escapedTerm})`, 'gi');
		const parts = text.split(regex);
		return parts.map((part, index) =>
			regex.test(part) ? <span key={index} className="searchTerm">{part}</span> : part
		);
	};

	const getButtonText = (progress) => {
		switch (progress) {
			case 0:
				return "Start";
			case 100:
				return "Restart";
			default:
				return "Continue";
		}
	};

	const renderButton = (searchResult) => {
		if (searchResult.ContentType === "") {
			return <Button icon={faClock} text={"Coming Soon"} type={ButtonType.Secondary} disabled />;
		}
		switch (searchResult.State) {
			case ModuleStateType.DisabledUpsell:
			case ModuleStateType.CourseTraversal:
				return <Button onClick={() => handleOpenLockModal(searchResult.State, searchResult.TraversalRule)} icon={faLock} text={"Locked"} type={ButtonType.Secondary} />;
			case ModuleStateType.DisabledNotPaid:
			case ModuleStateType.DisabledNotEnrolled:
			case ModuleStateType.DisabledUpsellPrereq:
			case ModuleStateType.Hidden:
				return <Button icon={faLock} text={"Locked"} type={ButtonType.Secondary} disabled />;
			default:
				return (
					<Button
						to={`/player#courseId-${searchResult.CategoryId}-moduleId-${searchResult.CourseId}-submoduleId-${searchResult.ModuleId}`}
						text={getButtonText(searchResult.Progress)}
					/>
				);
		}
	};

	if (!searchResults.Results || searchResults.Results.length === 0) {
		return searchResults.HasUnassignedContent ? (
			<div className="searchResultItem">
				These results contain content not assigned to you. Ask your ucSKILLS Admin to unlock this content for you.
			</div>
		) : (
			<div className="searchResultItem">
				No results found.
			</div>
		);
	}

	return (
		<>
			{searchResults.Results.map((searchResult) => (
				<div key={searchResult.Id} className="searchResultItem">
					<div className="searchResultItem-details">
						<div className="searchResultItem-details-text">
							<div className="searchResultItem-details-text-topline">
								<h2>{highlightTerm(searchResult.ModuleName, searchTerm)}</h2>
								<p><MediaType type={searchResult.ContentType} /></p>
							</div>
							<p>{highlightTerm(searchResult.CourseName, searchTerm)} <strong>&gt;</strong> {highlightTerm(searchResult.ModuleName, searchTerm)}</p>
						</div>
						<div className="searchResultItem-details-button">
							{renderButton(searchResult)}
						</div>
					</div>
				</div>
			))}
		</>
	);
};

export default SearchResultItem;
